import { AsyncGridColumn, AsyncGridValidRowModel } from '~/shared/ui/AsyncGrid'

export const addingColumn = <T extends AsyncGridValidRowModel>(
  columns: AsyncGridColumn<T>[],
  newColumn: AsyncGridColumn<T>,
  afterField: string,
): AsyncGridColumn<T>[] => {
  return columns.reduce((allColumns: AsyncGridColumn<T>[], column) => {
    if (afterField === column.field) return [...allColumns, column, newColumn]

    return [...allColumns, column]
  }, [])
}
